import * as log from 'loglevel';
log.setLevel(0);

export class Translate {
  public dictionaryIsLoad = false;
  public lang: string;

  private dictionary: Map<string, string>;

  constructor(lang: string) {
    const allowLang = ['en', 'de', 'fr', 'it'];
    if (allowLang.indexOf(lang) !== -1) {
      this.lang = lang;
    } else {
      log.info('Translate: unknown lang', lang);
    }
  }

  public async init(): Promise<boolean> {
    if (!this.dictionaryIsLoad) {
      await this.loadDictionary();
    }
    return true;
  }

  public text(key: string): string {
    try {
      const text = this.dictionary.get(key);

      if (text) {
        return text;
      } else {
        return '';
      }
    } catch (e) {
      log.info('can\'t load dictionary', e);
    }

    return '';
  }

  private async loadDictionary(): Promise<boolean> {
    log.info('loadDictionary');

    let dicModule;

    switch (this.lang) {
      case 'en': {
        dicModule = await import('@/lang/en');
        break;
      }
      case 'de': {
        dicModule = await import('@/lang/de');
        break;
      }
      case 'fr': {
        dicModule = await import('@/lang/fr');
        break;
      }
      case 'it': {
        dicModule = await import('@/lang/it');
        break;
      }
    }

    if (dicModule && dicModule.default) {
      this.dictionary = dicModule.default;

      this.dictionaryIsLoad = true;
      return true;
    }

    return false;
  }
}
